// extracted by mini-css-extract-plugin
module.exports = {"text":"_0fce717cdb--text--ypge4"};